import { GridViewWebComponent } from '../../../grid/gridView';

export enum Column {
  PAGE_NAME,
  STATUS,
  LAST_MODIFIED_DATE,
  LAST_EDITED_BY,
  PERMISSIONS,
  IN_POLICIES,
}

export enum ColumnKeys {
  PAGE_NAME = 'name',
  STATUS = 'status',
  LAST_MODIFIED_DATE = 'updated.date',
  LAST_EDITED_BY = 'updated.userName',
  PERMISSIONS = 'allowChangeByOtherUsers',
  IN_POLICIES = 'inPoliciesCount',
}

export enum WacPagesGridEvents {
  CLICK_ON_PAGE_NAME = 'clickOnPageName',
  CLICK_ON_IN_POLICIES = 'clickOnInPolicies',
  EDIT_ASSIGNMENTS = 'editAssignments',
  DELETE_PAGE = 'deletePage',
  SAVE_PAGE = 'savePage',
}

export enum StatusType {
  UNUSED = 1,
  USED = 2,
}
export enum Permissions {
  NOT_SHARED = 0,
  SHARED = 1,
}
export interface EnumValues {
  label: string;
  value: number;
}

export type WebAccessControlCustomPagesGrid = GridViewWebComponent<Column, ColumnKeys>
export type WacPagesReadRecordsResponse = ReadRecordsResponse<WacPagesRecord>;

export interface ReadRecordsResponse<Record> {
  success: boolean;
  data: Array<Record>;
  total: number;
}

export interface WacPagesRecord {
  _id?: string;
  name: string;
  logoLink: string;
  warningPage: string;
  blockPage: string;
  allowChangeByOtherUsers: boolean;
  company: Company;
  created?: Commit;
  updated?: Commit;
}

export interface RecordsToRemove {
  _id?: string;
  company: Company;
}

export interface Company {
  id: string;
  name?: string;
}

export interface Commit {
  date: string;
  userId: string;
  userName: string;
}

export enum WacPagesMethod {
  READ_RECORDS = 'readRecords',
  CREATE_RECORDS = 'createRecords',
  REMOVE_RECORDS = 'removeRecords',
  UPDATE_RECORDS = 'updateRecords',
  GET_SUGGESTED_NAME = 'getSuggestedName',
}
